var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2941_32324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 26.3313L23.0002 22.998M23.0002 22.998L19.6669 26.3313M23.0002 22.998V30.498M29.9919 28.323C30.8047 27.8798 31.4467 27.1787 31.8168 26.3301C32.1868 25.4816 32.2637 24.534 32.0354 23.6369C31.807 22.7397 31.2865 21.9442 30.5558 21.3758C29.8251 20.8074 28.9259 20.4986 28.0002 20.498H26.9502C26.698 19.5223 26.2278 18.6166 25.5752 17.8488C24.9225 17.081 24.1042 16.4712 23.182 16.0651C22.2597 15.6591 21.2573 15.4674 20.2503 15.5045C19.2433 15.5416 18.2578 15.8065 17.3679 16.2793C16.4779 16.7521 15.7068 17.4205 15.1124 18.2343C14.518 19.048 14.1158 19.9859 13.936 20.9774C13.7563 21.969 13.8036 22.9884 14.0746 23.959C14.3455 24.9296 14.8329 25.8262 15.5002 26.5813",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2941_32324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.ffbd737826fca544f9dc016086f2ef30.svg";
export { ForwardRef as ReactComponent };